import { render, staticRenderFns } from "./TopicAdd.vue?vue&type=template&id=020c2790&scoped=true&"
import script from "./TopicAdd.vue?vue&type=script&lang=js&"
export * from "./TopicAdd.vue?vue&type=script&lang=js&"
import style0 from "./TopicAdd.vue?vue&type=style&index=0&id=020c2790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020c2790",
  null
  
)

export default component.exports